<template>
  <div class="site-layout">
    <div class="site-layout-header sticky">
      <site-header />
    </div>
    <div class="site-main main-padding">
      <site-app-main />
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Layout',
  }
</script>
